import React from "react";
import "./ui-pending.scss";

export interface TabItem<K extends string = string> {
  key: K;
  label: React.ReactNode;
}

interface TabsProps<K extends string> {
  items: TabItem<K>[];
  active: K;
  onChange: (key: K) => void;
  /** Accessible name for the tab list. */
  label?: string;
  className?: string;
}

/**
 * Underlined tab list (design-system candidate; src/ui has no Tabs yet).
 * Same API and classes as DemoOps/ui-pending/Tabs so they can be merged into src/ui.
 */
export function Tabs<K extends string>({ items, active, onChange, label, className }: TabsProps<K>) {
  return (
    <div role="tablist" aria-label={label} className={["tesc-tabs", className].filter(Boolean).join(" ")}>
      {items.map((item) => {
        const selected = item.key === active;
        return (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={selected}
            className={["tesc-tabs__tab", selected && "tesc-tabs__tab--active"].filter(Boolean).join(" ")}
            onClick={() => onChange(item.key)}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
